// main.js

import '../scss/app.scss';

import { RemoteService } from './lib/data/remote/RemoteService.js';
import { AuthManager } from './lib/data/remote/AuthManager.js';
import { App } from './app/App.js';
import { routes, defaultRoutes } from './app/routes.js';
import { generatedRoutes } from './app/routes_generated.js';
import { menu } from './app/main-menu.js';
import { generatedMenuItems } from './app/main-menu_generated.js';
import { getConfig, loadConfig } from './config.js';
import { i18n } from './lib/globalization/i18n.js';
import { default as moment } from "moment";
import { default as momenttz } from "moment-timezone";
import { Services } from './lib/services/Services.js';
import { AppStorage } from './app/data/AppStorage.js';
import { Logger } from './lib/tracing/logger.js';
import * as ct from "./lib/ui/rendering/controls-templates-brewed.js";
import { preprocessGeneratedMenuItems, preprocessGeneratedRoutes, preprocessManualMenuItems } from './app/generated-artifacts-preprocessor.js';

const localeResourceModules = import.meta.glob(
    [
        './app/resources/locales/**/*.js',
        './lib/resources/locales/**/*.js',
    ],
    { eager: false }
);

async function startApp() {

    const config = await loadConfig('/config/config.json');
    Services.register('config', config);

    i18n.setLocaleResourceModules(localeResourceModules);
    await i18n.setLocale(config.locale, true);
    Services.register('i18n', i18n);

    const authService = new RemoteService({
        baseUrl: config.apiBaseUrl,
        defaultAuth: { type: 'cookie' },
        defaultContentType: 'json',
        defaultResponseType: 'json',
    });
    Services.register('authService', authService);

    const authManager = new AuthManager({
        authService,
        authMethod: 'cookie',
        storage: window.localStorage,  // pokud chceš persistentní login
        storageKey: 'inis-auth'
    });
    Services.register('authManager', authManager);

    const storage = new AppStorage();
    Services.register('storage', storage);

    const logger = new Logger();
    Services.register('logger', logger);

    Services.register('templates', ct);

    const processedGeneratedRoutes = preprocessGeneratedRoutes(generatedRoutes);
    const appRoutes = processedGeneratedRoutes.concat(routes);

    const processedManualMenuItems = preprocessManualMenuItems(menu, routes);
    const processedGeneratedMenuItems = preprocessGeneratedMenuItems(generatedMenuItems, appRoutes);
    const mainMenuDefs = processedManualMenuItems.concat(processedGeneratedMenuItems);

    const app = new App({
        authManager,
        routes: appRoutes,
        defaultRoutes,
        mainMenuDefs,
    });

    // -------------------- moment initialization

    moment.locale(config.locale);
    moment.tz.guess();
    moment.tz('Europe/Prague');

    // -------------------- app start

    app.start(document.getElementById('app'), { consumeRootElement: true });

}

startApp();
